import Immutable from 'immutable';
import * as authActions from 'actions/authenticate';
import * as ssActions from 'actions/server';
import { createReducer } from 'redux-immutablejs';
import { getCurrentEndpointKey } from 'utils/session-storage.js'
import { SIGN_OUT_COMPLETE, SIGN_OUT_ERROR } from 'actions/sign-out';
import { OAUTH_SIGN_IN_COMPLETE } from 'actions/oauth-sign-in';
import { STORE_CURRENT_ENDPOINT_KEY, SET_ENDPOINT_KEYS } from 'actions/configure-auth';

const initialState = Immutable.fromJS({
  attributes: null,
  isSignedIn: false,
  firstTimeLogin: false,
  mustResetPassword: false,
  endpointKey: null
});

export default createReducer(initialState, {
  [authActions.AUTHENTICATE_COMPLETE]: (state, { user }) => {
    return state.merge({
      attributes: user,
      isSignedIn: true,
      endpointKey: getCurrentEndpointKey()
  })},

  [ssActions.SS_TOKEN_VALIDATION_COMPLETE]: (state, { user, mustResetPassword, firstTimeLogin }) => {
    return state.merge({
      attributes: user,
      isSignedIn: true,
      firstTimeLogin,
      mustResetPassword
    });
  },

  [STORE_CURRENT_ENDPOINT_KEY]: (state, {currentEndpointKey}) => state.set('endpointKey', currentEndpointKey),
  [SET_ENDPOINT_KEYS]: (state, {currentEndpointKey}) => state.set('endpointKey', currentEndpointKey),

  [OAUTH_SIGN_IN_COMPLETE]: (state, { endpoint, user }) => state.merge({
    attributes: user,
    isSignedIn: true,
    endpointKey: endpoint
  }),

  [ssActions.SS_AUTH_TOKEN_UPDATE]: (state, {user, mustResetPassword, firstTimeLogin}) => {
    return state.merge({
      mustResetPassword,
      firstTimeLogin,
      isSignedIn: !!user,
      attributes: user
    });
  },

  [authActions.AUTHENTICATE_FAILURE]:    state => state.merge(initialState),
  [ssActions.SS_TOKEN_VALIDATION_ERROR]: state => state.merge(initialState),
  [SIGN_OUT_COMPLETE]:                   state => state.merge(initialState),
  [SIGN_OUT_ERROR]:                      state => state.merge(initialState),
});



// WEBPACK FOOTER //
// ./src/reducers/auth/user.js